//action types
export const GET_HELP_PAGES = 'GET_HELP_PAGE';

//get 
export function getHelpPages(data, callback) {
  return {
    type: GET_HELP_PAGES,
    payload : {data, callback},
  };
}